import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-media',
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.scss']
})
export class MediaComponent {

}
